<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header card-header-grey">
        <h4 class="card-title">
          Mon profil
        </h4>
      </div>
      <div class="card-body ">
        <div>
          <!-- Pills navs -->
          <ul [class]="isMobile ? 'nav nav-pills-rose nav-pills nav-fill text-center' : 'nav nav-pills-rose nav-pills nav-fill text-center flex-column'" id="ex1" role="tablist">
            <li class="nav-item" role="presentation">
              <a class="nav-link active"
                 id="v-pills-home-tab"
                 data-mdb-toggle="pill"
                 (click)="param.editDossier = true;param.editProfil = true;param.editPassword = false;param.editJobalert = false;param.editPj=false;param.editReponse = false;param.editStatus = false;"
                 href="#link10"
                 role="tab"
                 aria-controls="v-pills-home"
                 aria-selected="true"
                 [class.active]="param.editDossier" [class.disabled]="param.editPasswordForced">
                <div class="row">
                  <div class="col-12">
                    <i class="material-icons">person</i>
                  </div>
                  <div class="col-12">
                    Mettre à jour mon profil
                  </div>
                </div>
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link"
                 id="v-pills-profile-tab"
                 data-mdb-toggle="pill"
                 (click)="param.editPj=true;param.editDossier = false;param.editProfil = false;param.editPassword = false;param.editJobalert = false;param.editReponse = false;param.editStatus = false;"
                 href="#link11"
                 role="tab"
                 aria-controls="v-pills-profile"
                 aria-selected="false"
                 [class.active]="param.editPj" [class.disabled]="param.editPasswordForced">
                <div class="row">
                  <div class="col-12">
                    <i class="material-icons">insert_drive_file</i>
                  </div>
                  <div class="col-12">
                    Mon CV
                  </div>
                </div>
              </a>
            </li>
            <!--<li class="nav-item" role="presentation">
              <a class="nav-link"
                 id="v-pills-messages-tab"
                 data-mdb-toggle="pill"
                 (click)="param.editJobalert = true;param.editDossier = false;param.editProfil = false;param.editPassword = false;param.editPj=false;param.editReponse = false;param.editStatus = false;" href="#link12"
                 role="tab"
                 aria-controls="v-pills-messages"
                 aria-selected="false"
                 [class.active]="param.editJobalert" [class.disabled]="param.editPasswordForced">
                <div class="row">
                  <div class="col-12">
                    <i class="material-icons">notifications</i>
                  </div>
                  <div class="col-12">
                    Mes Job Alertes
                  </div>
                </div>
              </a>
            </li>
            <li class="nav-item" role="presentation">
              <a class="nav-link"
                 id="v-pills-messages-tab"
                 data-mdb-toggle="pill"
                 (click)="param.editReponse = true;param.editDossier = false;param.editProfil = false;param.editPassword = false;param.editPj=false;param.editJobalert = false;param.editStatus = false;" href="#link13"
                 role="tab"
                 aria-controls="v-pills-messages"
                 aria-selected="false"
                 [class.active]="param.editReponse" [class.disabled]="param.editPasswordForced">
                <div class="row">
                  <div class="col-12">
                    <i class="material-icons">history</i>
                  </div>
                  <div class="col-12">
                    Mon Historique des réponses
                  </div>
                </div>
              </a>
            </li>-->
          </ul>
          <!-- Pills navs -->
        </div>
      </div>
    </div>
  </div>
</div>
